/** AppSync Events channel for changes to one user's assigned-task list. */
export const taskAssigneeEventChannel = (userId: string): string => `tasks/${userId}`;
